<template>
  <div class="window-box">
    <div class="main-window-s">
      <div class="title">产业嘉宾类型选择</div>
      <div class="content">
        <div class="radio-box vertical">
          <label
            v-for="item in navOp"
            :key="item.type"
            ><input
              class="radio_dot"
              type="radio"
              name="vcRadio"
              :value="item.type"
              v-model="vcType"
            />{{ item.name }}</label
          >
        </div>
      </div>
      
      <button class="solid-btn" @click="next">下一步</button>
      <div class="text-btn-box">
        <span
          v-for="item in btnOp"
          :key="item.id"
          class="text-btn"
          @click="toPage(item.id)">{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
const portalUrl = process.env.VUE_APP_PORTAL_URL

export default {
  data() {
    return {
      navOp: [{
        type: 0,
        name: '创投嘉宾',
        route: '/1v1/investor'
      }, {
        type: 1,
        name: '市场嘉宾',
        route: '/market/sign'
      }],
      btnOp: [{
        id: '07178f56462d4bddaaa9c7e267ebaa48',
        name: '嘉宾章程'
      }, {
        id: '65b02c09113f458b9e26b009fa6d19db',
        name: '注册指南'
      }],
      vcType: 0
    };
  },
  created() {
    if (!this.$cookies.isKey("token") || this.$cookies.get("regType") != 1) {
      this.$msgbox({
        title: "提示",
        message: "请先登录产业嘉宾账号",
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "cancel-btn-color",
        confirmButtonClass: "btn-color",
        closeOnClickModal: false,
        closeOnPressEscape: false,
        callback: (action, instance) => {
          if (action == "confirm") {
            this.$router.push("/login");
          }
          if (action == "cancel") {
            this.$router.push("/userIndex");
          }
        }
      });
      return;
    }

    // let detailForm = sessionData("get", "UserInfo");
    // let isInvestor = false;
    // let isProGuest = false;

    // for (let i in detailForm.details) {
    //   if (detailForm.details[i].guestType == "10") {
    //     isInvestor = true;
    //   }
    //   if (detailForm.details[i].guestType == "11") {
    //     isProGuest = true;
    //   }
    // }
    // if (isProGuest && !isInvestor) {
    //   this.$msgbox({
    //     title: "提示",
    //     message: "您当前身份是一对一洽谈项目主创，请先注册新账号再来报名成为创投嘉宾",
    //     showClose: false,
    //     confirmButtonClass: "btn-color",
    //     closeOnClickModal: false,
    //     closeOnPressEscape: false,
    //     callback: (action, instance) => {
    //       if (action == "confirm") {
    //         this.$router.push("/login");
    //       }
    //     }
    //   });
    //   return;
    // }
    // this.$msgbox({
    //     title: "提示",
    //     message: "2022年金鸡创投嘉宾报名已截止",
    //     showClose: false,
    //     confirmButtonClass: "btn-color",
    //     closeOnClickModal: false,
    //     closeOnPressEscape: false,
    //     callback: (action, instance) => {
    //       if (action == "confirm") {
    //         this.$router.push({
    //           name: "userIndex"
    //         });
    //       }
    //     }
    // });
    return;
  },
  methods: {
    next() {
      let findObj = this.navOp.find(item => item.type == this.vcType);
      this.$router.push(findObj.route);
    },
    toPage(id) {
      window.open(`${portalUrl}/article_public.html?id=${id}`);
    }
  }
};
</script>

<style src="../../static/css/regist.css" scoped></style>

<style scoped>
.main-window-s {
  padding-bottom: 20px;
}

.main-window-s .content {
  min-height: 200px;
}

.text-btn-box {
  margin-top: 60px;
  justify-content: center;
}

.text-btn {
  margin: 0 10px;
}
</style>